import classNames from 'classnames';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CollectionPointSearchParams } from '../../../../../types/collectionPoints';
import { LOADING_TYPES } from '../../../../../utils/checkoutState';
import { getAssetUrl } from '../../../../../utils/config';
import LoadingIndicator from '../../../../atoms/LoadingIndicator';
import './style.scss';
export type FilterOption = {
  i18nKey: string;
  collectionPointType: string;
};

type FiltersProps = {
  onClick: (searchParams: CollectionPointSearchParams) => Promise<void>;
  availableFilters: FilterOption[];
  searchParams: CollectionPointSearchParams;
  isLoading: string;
};

const Filters = (props: FiltersProps) => {
  const { onClick, availableFilters, searchParams, isLoading } = props;
  const [activeFilter, setActiveFilter] = useState('');

  return (
    <div className="collection-point-filters" data-test-id="collection-point-filters">
      <ul>
        {availableFilters.map(filter => {
          const isFilterActive = activeFilter === filter.collectionPointType && !!searchParams.type;
          const filterImage = getAssetUrl(`collectionPoints/squares/${filter.i18nKey}.svg`);

          return (
            <li
              className={classNames({
                'active-filter': isFilterActive,
                'cursor-disabled': isLoading,
                'filter--loading': isLoading === LOADING_TYPES.collectionPointFilterSearch(filter.collectionPointType)
              })}
              onClick={() => {
                if (!isLoading) {
                  onClick(
                    isFilterActive ?
                      { ...searchParams, type: '' }
                    : { ...searchParams, type: filter.collectionPointType }
                  );
                  setActiveFilter(isFilterActive ? '' : filter.collectionPointType);
                }
              }}
              key={filter.collectionPointType}
              data-test-id={`collection-point-${filter.collectionPointType}`}
            >
              <img src={filterImage} />
              <LoadingIndicator isSmall />
              <div className="filter__label">
                <FormattedMessage id={`shipping.collectionPoint.types.${filter.i18nKey}`} />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Filters;
